module.exports = __webpack_public_path__ + "static/img/click.e1664ba4.gif";